module.exports = __webpack_public_path__ + "assets/images/industry_phase5.e7cd2209c1aa13734a5f3a975bceb5cb.svg";